import React from 'react';
import { useUser } from '@lore/auth';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import Form from './Form';
import { Helmet } from 'react-helmet-async';
import useRouter from '../../../hooks/useRouter';
import useSetupNavigation from '../useSetupNavigation';

export default function Layout(props) {
  const { history } = useRouter();
  const user = useUser();

  const navigation = useSetupNavigation(Urls.EDUCATOR_INTENT_ORGANIZATION);

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - Educator Intent - Organization</title>
      </Helmet>
      <Form
        user={user}
        navigation={navigation}
        // onPrevious={(newData) => history.push(Urls.ZIP_CODE)}
        // onNext={(newData) => history.push(Urls.NAME)}
        // onSkip={() => history.push(Urls.NAME)}
        onPrevious={(newData) => history.push(Urls.EDUCATOR_INTENT_SCHOOL)}
        onNext={() => history.push(Urls.SCHOOL)}
        onSkip={() => history.push(Urls.PARTNER_INTENT)}
      />
    </ParentLayout>
  );
};
